/**
 * @author yan st
 * @date 2022-08-09 10:15
 * @Description:
 */
import html2canvas from 'html2canvas';
import JsPDF from 'jspdf';
import BigNumber from 'bignumber.js'

/*
  VUE 计算小数不精确  使用方法来计算
   */
export const addAd = (a, b) => { // 加法 //调用addAd(0.1,0.2)    //0.3
  a = BigNumber(a);
  b = BigNumber(b);
  return a.plus(b).toNumber(); //结果需要用toNumber转为普通数字
}
  export const mutiply = (a, b) => { // 乘 mutiply(3,0.6);   //1.8
  a = BigNumber(a);
  b = BigNumber(b);
  return a.multipliedBy(b).toNumber();
}
export const minuss = (a, b) => { // 减 minuss(0.3,0.1);     //0.2
  a = BigNumber(a);
  b = BigNumber(b);
  return a.minus(b).toNumber();
}
export const devide = (a, b) => { // 除法 、、devide(355,113)  //  3.1415929203539825
  a = BigNumber(a);
  b = BigNumber(b);
  return a.dividedBy(b).toNumber();
}



/**
 * 获取Token
 */
export const getToken = () => {
  let token = window.localStorage.getItem('token')
  return JSON.parse(token) ? JSON.parse(token) : '';
}

/*
* 时间转换
* */
export const zhDate = (date, type) => {
  let now = new Date(date)
  let year = now.getFullYear()
  let month = now.getMonth() + 1
  let day = now.getDate()
  let hour = now.getHours()
  let minute = now.getMinutes()
  let second = now.getSeconds()
  if (type === 1) {
    return year + "-" + getzf(month) + "-" + getzf(day) + "  " + getzf(hour) + ":" + getzf(minute)
  } else if (type === 2) {
    return year + "-" + getzf(month) + "-" + getzf(day) + "  " + getzf(hour) + ":" + getzf(minute) + ":" + getzf(second)
  } else if (type === 3) {
    return getzf(hour) + ":" + getzf(minute)
  } else if (type === 4) {
    return year
  } else if(type === 5) {
    return year + "-" + getzf(month)
  } else if(type === 6) {
    return year + "年" + getzf(month) + "月" + getzf(day) + "日"
  } else {
    return year + "-" + getzf(month) + "-" + getzf(day)
  }
}

function getzf(num) {
  if (parseInt(num) < 10) {
    num = '0' + num
  }
  return num
}

export const zhRmb = (num) => {
  if (Number(num) > 10000) {
    return (Number(num) / 10000).toFixed(2) + '万元'
  } else {
    return num + '元'
  }
}

export const getUrlBase64=(url)=> {
  return new Promise(resolve => {
    let canvas = document.createElement('canvas')
    let ctx = canvas.getContext('2d')
    let img = new Image()
    img.crossOrigin = 'anonymous' //允许跨域
    img.src = url
    img.onload = function() {
      canvas.height = 300
      canvas.width = 300
      ctx.drawImage(img, 0, 0, 300, 300)
      let dataURL = canvas.toDataURL('image/png')
      canvas = null
      resolve(dataURL)
    }
  })
}

/*
*
* */
export const getYearAndMonth = (start, end) => {
  var result = [];
  var starts = start.split('-');
  var ends = end.split('-');
  var staYear = parseInt(starts[0]);
  var staMon = parseInt(starts[1]);
  var endYear = parseInt(ends[0]);
  var endMon = parseInt(ends[1]);
  while (staYear <= endYear) {
    if (staYear === endYear) {
      while (staMon < endMon) {
        staMon++;
        var str = staYear + '-'+(staMon >= 10 ? staMon : '0' + staMon);
        result.push(str);
      }
      staYear++;
    } else {
      staMon++;
      if (staMon > 12) {
        staMon = 1;
        staYear++;
      }
      let str = staYear + '-'+(staMon >= 10 ? staMon : '0' + staMon);
      result.push(str);
    }
  }
  // console.log(result)
  return result;



}

//  element时间插件 时间 转换为 yyyy-mm-ss
export const resDate = (date) => {
  const d = new Date(date)
  let time = d.getFullYear() + '-' + p((d.getMonth() + 1)) + '-' + p(d.getDate())
  return time

}
const p = (s) => {
  return s < 10 ? '0' + s : s
}

/**
 * @param  ele          要生成 pdf 的DOM元素（容器）
 * @param  padfName    PDF文件生成后的文件名字
 * */
export const downloadPDF = (ele, pdfName) => {
  let eleW = ele.offsetWidth;// 获得该容器的宽
  let eleH = ele.offsetHeight;// 获得该容器的高
  //  let eleR =  document.querySelector('#exportPdf')   //容器真实高度
  let eleOffsetTop = ele.offsetTop;  // 获得该容器到文档顶部的距离
  let eleOffsetLeft = ele.offsetLeft; // 获得该容器到文档最左的距离
  var canvas = document.createElement("canvas");
  var abs = 0;
  let win_in = document.documentElement.clientWidth || document.body.clientWidth; // 获得当前可视窗口的宽度（不包含滚动条）
  let win_out = window.innerWidth; // 获得当前窗口的宽度（包含滚动条）
  if (win_out > win_in) {
    // abs = (win_o - win_i)/2;    // 获得滚动条长度的一半
    abs = (win_out - win_in) / 2; // 获得滚动条宽度的一半
    // console.log(a, '新abs');
  }
  canvas.width = eleW* 2 ; // 将画布宽&&高放大两倍
  canvas.height = eleH * 2;
  var context = canvas.getContext("2d");
  context.scale(2, 2);
  context.translate(-eleOffsetLeft - abs, -eleOffsetTop);
  // 这里默认横向没有滚动条的情况，因为offset.left(),有无滚动条的时候存在差值，因此
  // translate的时候，要把这个差值去掉
  html2canvas(ele, {
    dpi: 300,
    // allowTaint: true,  //允许 canvas 污染， allowTaint参数要去掉，否则是无法通过toDataURL导出canvas数据的
    useCORS: true  //允许canvas画布内 可以跨域请求外部链接图片, 允许跨域请求。
  }).then((canvas) => {
    var contentWidth = canvas.width;
    var contentHeight = canvas.height;
    //一页pdf显示html页面生成的canvas高度;
    var pageHeight = contentWidth / 592.28 * 841.89;
    //未生成pdf的html页面高度
    var leftHeight = contentHeight;
    //页面偏移
    var position = 0;
    //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
    var imgWidth = 595.28;
    var imgHeight = 595.28 / contentWidth * contentHeight;
    var pageData = canvas.toDataURL('image/jpeg', 1.0);
    var pdf = new JsPDF('', 'pt', 'a4');
    //有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
    //当内容未超过pdf一页显示的范围，无需分页
    if (leftHeight < pageHeight) {
      //在pdf.addImage(pageData, 'JPEG', 左，上，宽度，高度)设置在pdf中显示；
      pdf.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight);
      // pdf.addImage(pageData, 'JPEG', 20, 40, imgWidth, imgHeight);

    } else {    // 分页
      while (leftHeight > 0) {
        pdf.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight);
        leftHeight -= pageHeight;
        position -= 841.89;
        //避免添加空白页
        if (leftHeight > 0) {
          pdf.addPage();
        }
      }
    }
    //可动态生成
    pdf.save(pdfName);
  })
}


//秒数转化为时分秒
export const formatSeconds = (seconds) => {
  let hour = Math.floor(seconds / 3600) >= 10 ? Math.floor(seconds / 3600) : '0' + Math.floor(seconds / 3600);
  seconds -= 3600 * hour;
  let min = Math.floor(seconds / 60) >= 10 ? Math.floor(seconds / 60) : '0' + Math.floor(seconds / 60);
  seconds -= 60 * min;
  let sec = seconds >= 10 ? seconds : '0' + seconds;
  return hour + ':' + min + ':' + sec;
}


export const browserRedirect = () => {   //  1 手机 2 pc
  var sUserAgent = navigator.userAgent.toLowerCase();
  var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
  var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
  var bIsMidp = sUserAgent.match(/midp/i) == "midp";
  var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
  var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
  var bIsAndroid = sUserAgent.match(/android/i) == "android";
  var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
  var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
  if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
    return false
  } else {
    return true
  }
}


/*
* 获取地址按参数
* */
export const getQueryString = (name) => {
  var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if(r!=null)return  unescape(r[2]); return null;
}


export const formatHtml = (str, replace = '') => {
  const pattern = /<(\S*?)[^>]*>.*?|<.*? > /ig
  return str.replace(pattern, replace).replace(/&nbsp;/ig, "").replace(/&emsp;/ig, "")
}



/**
 * form表单验证 提示错误信息 跳转到第一条错误的位置
 * @param validates this.$refs[formName].validate((valid, validates) => {
          if (valid) {
              this.submitChange()
          } else {
              scrollIntoView(this, validates)
          }
      });
 */
export const scrollIntoView = (_this, validates,show = true) => {
  let error = Object.values(validates).shift().shift()
  let split = error.field.split('.')
  if (split.length > 3) {
    split.splice(2, 2)
  }
  let refs = _this.$refs[split.join('')]
  let dom = refs instanceof Array ? refs[0] : refs
  if (show) {
    _this.$confirm(error.message, "提示", {
      confirmButtonText: "确定",
      showCancelButton: false,
      type: "warning",
    }).then(() => {
      dom.$el.scrollIntoView({
        block: 'center', // 当前元素显示在视图区域中间
        behavior: 'auto' // 滚动速度
      })
    }).catch(() => {

    });
  } else {
    dom.$el.scrollIntoView({
      block: 'center', // 当前元素显示在视图区域中间
      behavior: 'auto' // 滚动速度
    })
  }
}


/**
 * value转换为label
 * @param {*} val
 * @param {*} arr
 * @param {*} format
 * @returns
 */
export const find2CN = (val, arr,format = {key:'value',value:'label'}) => {
  let _find = arr.find(item => Number(val) === item[format.key])
  return _find ? _find[format.value] : ''
}


















